import StepType from "./step.type";

export default class PaymentStepModel extends StepType {}
